import type React from 'react';

import type { MultiLang } from '../../../../config';
import CreativeCommons from './CreativeCommons';
import Description from './Description';

interface Props {
    lang: MultiLang;
    rights: string;
    useCc: number;
    ccCommercialUse: number;
    ccModification: number;
}

const Rights: React.FC<Props> = (props) => {
    const { lang, rights, useCc, ccCommercialUse, ccModification } = props;
    if (useCc === 0) {
        return <Description lang={lang} description={rights} className="rights" />;
    }
    return <CreativeCommons lang={lang} ccCommercialUse={ccCommercialUse} ccModification={ccModification} />;
};

export default Rights;
